(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-video"] && !window.DesignMode) return;
  try {
    
  $('.video-section__overlay').click(function() {
    $(this).hide();
    $('.video-section__container video').trigger('play');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-bundle"] && !window.DesignMode) return;
  try {
    
  $('.benefits-bundle__nav-item').click(function() {
    var idx = $(this).data('idx');

    $('.benefits-bundle__nav-item.active').removeClass('active');
    $(this).addClass('active');
 
    $('.benefits-bundle__item.active').removeClass('active');
    $(`.benefits-bundle__item[data-idx="${idx}"]`).addClass('active'); 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-bar"] && !window.DesignMode) return;
  try {
    
  var $links = $('.collection-bar__btn'); 
  var navHeight = $('.header').outerHeight() + $('.collection-bar').outerHeight();
  $(window).scroll(function() {
    var fromTop = $(window).scrollTop();

    if ($links.length) {
      $links.each(function(i, link) {
        var sectionID = '#' + $(link).data('section');
        var $section = $(`${sectionID}`);
        
        if (
          ($section.offset().top - navHeight) <= fromTop &&
          ($section.offset().top - navHeight) + $section.outerHeight() > fromTop
        ) {
          $(link).addClass('active');
        } else {
          $(link).removeClass('active');
        }
      }); 
    } 
  });

  // Scroll to link
    $('.collection-bar__btn').click(function(e) {
      e.preventDefault();
      var section = $(this).data('section');

      $('html, body').animate({
        scrollTop: $(`#${section}`).offset().top - navHeight + 5
      }, 500);
    }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facts-slider"] && !window.DesignMode) return;
  try {
    
  $('.facts-slider__slider').slick({
    appendArrows: $('.facts-slider__arrows'),
    prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"]) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-marquee"] && !window.DesignMode) return;
  try {
    
  if($('.footer-marquee__marquee.footer-marquee__slider')) {
    $('.footer-marquee__marquee.footer-marquee__slider').slick()
  }  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $('.footer-block__heading:not(.news)').click(function() {
    $(this).toggleClass('active');
    $(this).siblings('.footer-block__details-content').slideToggle(300);
  });

  // Credits
  const creditsButtons = document.querySelectorAll('a[href="#credits"]');
  const creditsCloseButtons = document.querySelectorAll('.site-credits__close');
  const credits = document.querySelector('.site-credits');

  creditsButtons.forEach(creditsButton => {
    creditsButton.addEventListener('click', event => {
      event.preventDefault();
      credits.classList.add('is-visible');

      document.addEventListener('keydown', function(event){
        if (event.key === "Escape") {
          credits.classList.remove('is-visible');
        }
      });
    });
  });

  creditsCloseButtons.forEach(creditsCloseButton => {
    creditsCloseButton.addEventListener('click', event => {
      credits.classList.remove('is-visible');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  const openSearchButtons = document.querySelectorAll('.js-open-search');
  const closeSearchButtons = document.querySelectorAll('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearchButtons.forEach(openSearch => {
    openSearch.addEventListener('click', () => {
      if (search.classList.contains('is-visible')) {
        search.classList.remove('is-visible');
      } else {
        search.classList.add('is-visible');
      }
    });
  });

  closeSearchButtons.forEach(closeSearch => {
    closeSearch.addEventListener('click', () => {
      search.classList.remove('is-visible');
    }); 
  });

  $('.mega-menu-blogs__menu-item-js').click(event => {
    event.preventDefault();
    const tab = $(event.target).data('tab');

    if (!$(event.target).hasClass('active')) {
      $('.mega-menu-blogs__menu-item-js.active').removeClass('active');
      $(event.target).addClass('active');

      $('.mega-menu-blogs__container.active').removeClass('active');
      $(`.mega-menu-blogs__container[data-tab="${tab}"]`).addClass('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const openSearchButtons = document.querySelectorAll('.js-open-search');
  const closeSearchButtons = document.querySelectorAll('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearchButtons.forEach(openSearch => {
    openSearch.addEventListener('click', () => {
      if (search.classList.contains('is-visible')) {
        search.classList.remove('is-visible');
      } else {
        search.classList.add('is-visible');
      }
    });
  });

  closeSearchButtons.forEach(closeSearch => {
    closeSearch.addEventListener('click', () => {
      search.classList.remove('is-visible');
    }); 
  });

  $('.mega-menu-blogs__menu-item-js').click(event => {
    event.preventDefault();
    const tab = $(event.target).data('tab');

    if (!$(event.target).hasClass('active')) {
      $('.mega-menu-blogs__menu-item-js.active').removeClass('active');
      $(event.target).addClass('active');

      $('.mega-menu-blogs__container.active').removeClass('active');
      $(`.mega-menu-blogs__container[data-tab="${tab}"]`).addClass('active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cro-gf"] && !window.DesignMode) return;
  try {
    
  $(window).ready(function() {
    let heroTL = gsap.timeline({
      ease: 'power3'
    })
    .to('.hero__images', {
      duration: 2,
      delay: 0.5,
      opacity: 1
    })
    .to('.hero__fade-in-up', {
      duration: 1,
      opacity: 1,
      y: 0,
      stagger: .2
    }, '<1');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !window.DesignMode) return;
  try {
    
  $(window).ready(function() {
    let heroTL = gsap.timeline({
      ease: 'power3'
    })
    .to('.hero__images', {
      duration: 2,
      delay: 0.5,
      opacity: 1
    })
    .to('.hero__fade-in-up', {
      duration: 1,
      opacity: 1,
      y: 0,
      stagger: .2
    }, '<1');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-slider"] && !window.DesignMode) return;
  try {
    
  $('.how-it-works__slider').slick({
    appendArrows: $('.how-it-works__arrows'),
    prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  if (getCookie('legalCookie')){
    $('.legal-popup').fadeOut(400);
  } else{
    $('.legal-popup').fadeIn(400);
  }

  $('.legal-popup__close').click(function () {
    var day = $('.legal-popup').attr('data-day');

    $('.legal-popup').fadeOut(400);
    setCookie('legalCookie', true, day)
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-main-product"] && !window.DesignMode) return;
  try {
    
  $('.product__description-toggle-control').click(function() {
    $('.product__description--short').toggle();
    $('.product__description--long').toggle();
    $(this).hide();
  });

  $('.product__dropdown-header').click(function() {
    $(this).toggleClass('active');
    $(this).siblings('.product__dropdown-content').slideToggle(300);
  });
  
  $('#video-action-desktop, #video-action-mobile').click(function(){
    document.cookie = "convertTracking=video";
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  $('.video-section__overlay').click(function() {
    $(this).hide();
    $('.video-section__container video').trigger('play');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  $('.main-blog__filter-item-header').click(function() {
    $(this).toggleClass('active');
    $(this).siblings('.main-blog__filter-item-content').slideToggle(200);
  });

  $('.main-blog__featured-video-item').click(function() {
	var url = $(this).data('url');

    $('#video-player').attr('src', url);
  }); 
 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-grouped"]) return;
  try {
    
  $('.product__description-toggle-control').click(function() {
    $('.product__description--short').toggle();
    $('.product__description--long').toggle();
    $(this).hide();
  });

  $('.product__dropdown-header').click(function() {
    $(this).toggleClass('active');
    $(this).siblings('.product__dropdown-content').slideToggle(300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $('.product__description-toggle-control').click(function() {
    $('.product__description--short').toggle();
    $('.product__description--long').toggle();
    $(this).hide();
  });

  $('.product__dropdown-header').click(function() {
    $(this).toggleClass('active');
    $(this).siblings('.product__dropdown-content').slideToggle(300);
  });
  
  $('#video-action-desktop, #video-action-mobile').click(function(){
    document.cookie = "convertTracking=video";
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !window.DesignMode) return;
  try {
    
  // Move main nav on scroll
var scrollTop     = $(window).scrollTop(),
    elementOffset = $('.product-bar').offset().top,
    distance      = (elementOffset - scrollTop);
  
  $(window).scroll(function() {
    if ($(window).width() > 1050) {
      if ($(window).scrollTop() > elementOffset + 48) {
        // $('#shopify-section-header').css('transform', 'translateY(-100%)');
        // $('#shopify-section-header').css('top', '0px');
        $('.product-bar').addClass('active');
      } else {
        // $('#shopify-section-header').css('transform', 'translateY(0)');
        $('.product-bar').removeClass('active');
        // $('#shopify-section-header').css('top', '31px');
      }
    } else {
      if ($(window).scrollTop() > elementOffset + 33) {
        $('.product-bar').addClass('active');
      } else {
        // $('#shopify-section-header').css('transform', 'translateY(0)');
        $('.product-bar').removeClass('active');
        // $('#shopify-section-header').css('top', '31px');
      }
    }
  });

  // Make links active on scroll
  var $links = $('.product-bar__nav-container button');
  var navHeight = $('.product-bar').outerHeight();
  $(window).scroll(function() {
    var fromTop = $(window).scrollTop();

    if ($links.length) {
      $links.each(function(i, link) {
        var sectionID = '#' + $(link).data('section');
        var $section = $(`${sectionID}`);
        if (!!$section.offset()) { 
        if (
          ($section.offset().top - navHeight) <= fromTop &&
          ($section.offset().top - navHeight) + $section.outerHeight() > fromTop
        ) {
          $(link).addClass('active');
        } else {
          $(link).removeClass('active');
        }
        }
      });
    }
  });

  // Scroll to link
  $('.product-bar__nav-container button').click(function(e) {
    e.preventDefault();
    var section = $(this).data('section');

    $('html, body').animate({
      scrollTop: $(`#${section}`).offset().top - navHeight + 5
    }, 500);
  });

  // Scroll to top
  $('.product__anchor-top').click(function() {
    $(window).scrollTo(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail-slider"] && !window.DesignMode) return;
  try {
    
  $('.product-details__images-slider').slick({
    appendArrows: $('.product-details__arrows'),
    prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
    asNavFor: $('.product-details__content-slider'),
    fade: true
  });

  $('.product-details__content-slider').slick({
    arrows: false,
    asNavFor: $('.product-details__images-slider')
  });

  // Sync thumbnails with slider
  $('.product-details__images-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $('.product-details__navigation-item').removeClass('active');
    $(`.product-details__navigation-item[data-idx="${nextSlide}"]`).addClass('active');
  });

  // Sync slider with thumbnails
  $('.product-details__navigation-item').on('click', function() {
    var slide = Number($(this).data('idx'));

    $('.product-details__navigation-item').removeClass('active');
    $(this).addClass('active');

    $('.product-details__images-slider').slick('slickGoTo', slide);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !window.DesignMode) return;
  try {
    
  $(window).ready(function() {
    /* let productSliderTL = gsap.timeline({
      ease: 'power3',
      scrollTrigger: {
        trigger: '.product-slider',
        start: 'top 95%',
        end: 'bottom',
        markers: true
      }
    })
    .to('.product-slider__group-item', {
      duration: 1,
      opacity: 1,
      y: 0,
      stagger: .2
    }, '<') */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !window.DesignMode) return;
  try {
    
  $('.video-section__overlay').click(function() {
    $(this).hide();
    $('.video-section__container video').trigger('play');
  });

  $('button.modal__close, .modal__overlay').click(function () {
    var iframe = document.getElementById('youtube-video');

    if(iframe) {
      var iframeSrc = iframe.src;
      iframe.src = iframeSrc; // Reloads the iframe to stop the video
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wide-video"] && !window.DesignMode) return;
  try {
    
  $('.video-section__overlay').click(function(e) {
    $(this).hide();
      const iframe = document.querySelector('.video-section__container iframe');
      if (iframe) {
        const src = iframe.getAttribute('src');
        const symbol = iframe.src.indexOf("?") > -1 ? "&" : "?";
        console.log(iframe, src + symbol + 'autoplay=1')
        iframe.setAttribute('src', src + symbol + 'autoplay=1');
      } else {
        var videoSource = $('.video-section__container .video-section__video source');
        
        if (videoSource) {
          var dataSrc = videoSource.data("src");
          videoSource.attr("src", dataSrc);
          videoSource.get(0).parentNode.load();
          videoSource.get(0).parentNode.play();
        }
      }


    // $('.video-section__container video').trigger('play');
  });

  } catch(e) { console.error(e); }
})();
})();
